module.exports = __webpack_public_path__ + "static/media/Amaryllis.2ad04788.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Amaryllis.woff
// module id = 3008
// module chunks = 68